"use client";

import { useTenant } from "@tillix/tenants/react";
import { BaseFieldError, type BaseFieldErrorProps } from "./field-error";
import ConEdisonFieldError from "./field-error.con-edison";
import type { OptionalTenantProp } from "../../../../types";

export function FieldError(props: BaseFieldErrorProps & OptionalTenantProp) {
  const contextTenant = useTenant();

  const tenantRefId = props.tenant?.id ?? contextTenant?.id;

  switch (tenantRefId) {
    case "con-edison":
      return <ConEdisonFieldError {...props} />;

    default:
      return <BaseFieldError {...props} />;
  }
}
